export default function findLinkInAncestorElements(element) {
  if (element.tagName == "A" && element.href) {
    return element
  } else if (element.parentElement) {
    return findLinkInAncestorElements(element.parentElement)
  } else {
    return null
  }
}
